import { useEffect, useLayoutEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import routes from '../../../../../Routes/routes';
import {areTimesEqual, CREATE_STEP, GEOFENCES_MODEL, isCloseTimeInvalid, isCloseTimeNotValid} from '../Model/Model';
import HandleChange from '../../../../../Helpers/HandleChange';
import {DEFAULT_LATITUDE, DEFAULT_LONGITUDE, errorMsg, getGeolocation, getTimeFormatFromTime} from "../../../../../Apis/functions";
import {toast} from "react-toastify";
import {CreateGeofence} from "../../../../../reduxToolkit/FineGeofence/FineGeofenceApi";
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const GeofencesCreateApp = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    let {state} = location;
    const [activeStep, setActiveStep] = useState(0);
    const [emptyFields, setEmptyFields] = useState(false);
    const [steps, setSteps] = useState([]);
    const [item, setItem] = useState({ ...GEOFENCES_MODEL });
    const { handleChange } = HandleChange({ model: item, setModel: setItem });
    const [dayArray, setDayArray] = useState([]);
    const [geofences, setGeofences] = useState([]);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const [latitude, setLatitude] = useState(DEFAULT_LATITUDE);
    const [longitude, setLongitude] = useState(DEFAULT_LONGITUDE);
    const isCloseTimeInvalid = isCloseTimeNotValid(item.opening, item.closing);
    const isEqualTimes = areTimesEqual(item.opening, item.closing);
    useLayoutEffect(() => {
        getGeolocation({ setLatitude, setLongitude });
        setSteps([t('details'), t('active_schedule'), t('define_area'), t('summary')]);
    }, [permission, t]);

    // Validate required fields for the current step
    const handleStepSetUp = () => {
        let isEmpty;
        switch (activeStep) {
            case CREATE_STEP.DETAILS:
                isEmpty = !item.isValidDetails();
                break;
            case CREATE_STEP.ACTIVE_SCHEDULE:
                isEmpty = !item.isValidSchedule(dayArray);
                break;
            case CREATE_STEP.DEFINE_AREA:
                isEmpty = !item.isValidArea(geofences);
                break;
            default:
                isEmpty = false;
        }
        setEmptyFields(isEmpty);
        return !isEmpty;
    };

    useEffect(() => {
        if (geofences.length > 0) {
            setEmptyFields(false);
        }
    }, [geofences]);
    
    /**
     * Update the currently active step in the creation wizard.
     */
    const handleStepChange = (step) => {
        setActiveStep(step);
    };

    /**
     * Handle geofence creation submission.
     * Validates all steps before generating the request body.
     */
    const handleAdd = () => {
        setEmptyFields(false);
        if (!item.isValidDetails() || !item.isValidSchedule(dayArray) || !item.isValidArea(geofences)) {
            setEmptyFields(true);
            return;
        }
        dispatch(CreateGeofence(item.toRegister(geofences[0].coordinates, dayArray))).then(({ payload: { data: { success, code } } }) => {
            if (success) {
                toast.success(t('has_been_created_successfully'));
                navigate(routes.traffic.list, { state })
            } else {
                errorMsg(code);
            }
        });
    };
    const handleOnBack = () => {
        navigate(
            routes.traffic.list, {
                state: state
            });
    }


    return {
        t,
        activeStep,
        setActiveStep,
        steps,
        handleStepChange,
        handleStepSetUp,
        setDayArray,
        dayArray,
        handleAdd,
        item,
        emptyFields,
        handleChange,
        setItem,
        geofences,
        setGeofences,
        latitude,
        setLatitude,
        longitude,
        setLongitude,
        handleOnBack,
        isCloseTimeInvalid,
        isEqualTimes,
      
    };
};

export default GeofencesCreateApp;
